export default "__VITE_ASSET__CcqmG$ny__"